import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import HubIcon from "@mui/icons-material/Hub";
import SpeedIcon from "@mui/icons-material/Speed";
import FinlandFlagEmojiIcon from "shared/components/icons/flags/FinlandFlagEmojiIcon";
import FrenchFlagEmojiIcon from "shared/components/icons/flags/FrenchFlagEmojiIcon";
import {
  AfrrEngagementResourcesEnum,
  EcpResourcesEnum,
  FinlandCommunicationResourcesEnum,
  MaintenanceResourcesEnum,
  MecapaResourcesEnum,
  OptimizerResourcesEnum,
  PlanningResourcesEnum,
  RegelleistungResourcesEnum,
  RteCommunicationV2ResourcesEnum,
  SiteResourcesEnum,
  TestsFingridEnum,
  TestsRteResourcesEnum,
  TopNiveauResourcesEnum,
} from "shared/enums/resourceMappings";

interface MenuItem {
  label: string;
  icon?: JSX.Element;
  path?: string;
  listItems?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    label: "Jbox",
    icon: <BatteryChargingFullIcon />,
    listItems: [
      { label: "Sites", path: SiteResourcesEnum.Sites },
      { label: "Groups", path: SiteResourcesEnum.Groups },
      { label: "Associations", path: SiteResourcesEnum.Associations },
    ],
  },
  {
    label: "Fleet Status",
    icon: <DeviceThermostatIcon />,

    listItems: [
      {
        label: "Maintenances",
        path: MaintenanceResourcesEnum.Maintenance,
      },
      { label: "Statuses", path: SiteResourcesEnum.Statuses },
    ],
  },
  {
    label: "Plannification",
    icon: <DateRangeIcon />,
    listItems: [
      {
        label: "Plannings",
        path: PlanningResourcesEnum.Plannings,
      },
      {
        label: "Planning Masks",
        path: PlanningResourcesEnum.PlanningMasks,
      },
    ],
  },
  {
    label: "Performance Tests",
    icon: <SpeedIcon />,
    listItems: [
      { label: "Report Generation", path: SiteResourcesEnum.PerformanceChronicleGeneration },
      { label: "Config Validation", path: SiteResourcesEnum.PerformanceChronicles },
      {
        label: "Send MSI chronicle for JBox 2",
        path: SiteResourcesEnum.PerformanceChronicleTestSending,
      },
    ],
  },

  {
    label: "France",
    icon: <FrenchFlagEmojiIcon />,
    listItems: [
      {
        label: "Regelleistung",
        listItems: [
          { label: "Bids", path: RegelleistungResourcesEnum.RegelleistungBids },
          { label: "Bids Visualization", path: RegelleistungResourcesEnum.RegelleistungBidsVisualization },
        ],
      },
      {
        label: "RACOON",
        listItems: [
          {
            label: "Visualization Chart",
            path: AfrrEngagementResourcesEnum.Engagement,
          },
          {
            label: "Bids",
            path: AfrrEngagementResourcesEnum.Point,
          },
        ],
      },
      {
        label: "TOPNIVEAU",
        listItems: [
          {
            label: "Bids",
            path: TopNiveauResourcesEnum.TopNiveauBids,
          },
        ],
      },

      {
        label: "Tests TSO",
        listItems: [
          { label: "Tests AFRR RTE", path: TestsRteResourcesEnum.TestsAfrrRte },
          { label: "Tests FCR RTE ", path: TestsRteResourcesEnum.TestsFcrRte },
          {
            label: " RTE Phase 2",
            path: SiteResourcesEnum.CertificationRtePhase2,
          },
        ],
      },
      {
        label: "Mecapa",
        listItems: [
          {
            label: "Emax J",
            path: MecapaResourcesEnum.EmaxJGates,
          },
          {
            label: "Emax H",
            path: MecapaResourcesEnum.EmaxHGates,
          },
        ],
      },
      {
        label: "RTE communication V2",
        listItems: [
          {
            label: "Tranches TM",
            path: RteCommunicationV2ResourcesEnum.RteCommunicationConfig,
          },
          {
            label: "Fake Pas",
            path: RteCommunicationV2ResourcesEnum.RteCommunicationFakePa,
          },
          {
            label: "Market Configurations",
            path: RteCommunicationV2ResourcesEnum.RteCommunicationMarketConfig,
          },
          {
            label: "Test Configurations",
            path: RteCommunicationV2ResourcesEnum.RteCommunicationTestConfig,
          },
        ],
      },
    ],
  },

  {
    label: "Finland",
    icon: <FinlandFlagEmojiIcon />,
    listItems: [
      {
        label: "ECP",
        listItems: [
          {
            label: "ECP Reserve Plan Points",
            path: EcpResourcesEnum.EcpReservePlanPoints,
          },
          {
            label: "ECP Reserve Plan Gates",
            path: EcpResourcesEnum.EcpReservePlanGates,
          },
          {
            label: "FCR D Visualization Chart",
            path: EcpResourcesEnum.EcpFcrDVisualization,
          },
          {
            label: "FCR N Visualization Chart",
            path: EcpResourcesEnum.EcpFcrNVisualization,
          },
        ],
      },
      {
        label: "Finland Communication",
        listItems: [
          {
            label: "Config Protocol Parameters",
            path: FinlandCommunicationResourcesEnum.ConfigProtocolParameters,
          },
        ],
      },
      {
        label: "Tests",
        listItems: [
          {
            label: "Test Fingrid FCR N",
            path: TestsFingridEnum.TestFingridFcrN,
          },
          {
            label: "Test Fingrid FCR D",
            path: TestsFingridEnum.TestFingridFcrD,
          },
          {
            label: "Test Fingrid AFRR",
            path: TestsFingridEnum.TestFingridAfrr,
          },
          {
            label: "CSV Generation",
            path: TestsFingridEnum.TestFingridCsvGeneration,
          },
        ],
      },
    ],
  },

  {
    label: "Optimizer",
    icon: <HubIcon />,
    listItems: [
      {
        label: "Certification Tests",
        path: OptimizerResourcesEnum.OptiCertificationsTests,
      },
      { label: "Certifications", path: OptimizerResourcesEnum.OptiCertifications },
      {
        label: "Groups Certifications",
        path: OptimizerResourcesEnum.OptiGroupsCertifications,
      },
      { label: "Opti tasks", path: OptimizerResourcesEnum.OptiTasks },
    ],
  },
];

/**
 * Recursively traverses a list of menu items to build a mapping
 * from each leaf's `path` to an array of its parent labels.
 *
 * @param items - The current list of menu items.
 * @param parentChain - An array of labels representing the ancestry.
 * @returns An object whose keys are paths and values are arrays of parent labels.
 */
function buildPathParentMapping(items: MenuItem[], parentChain: string[] = []): Record<string, string[]> {
  return items.reduce<Record<string, string[]>>((acc, item) => {
    // If the item has a path, record it with the current parent chain.
    if (item.path) {
      acc[item.path] = parentChain;
    }
    // If the item has nested listItems, traverse them.
    if (item.listItems) {
      // Pass down a new chain that includes this item's label.
      const childMapping = buildPathParentMapping(item.listItems, [...parentChain, item.label]);
      Object.assign(acc, childMapping);
    }
    return acc;
  }, {});
}

export const breadcrumbInfos = menuItems.reduce<Record<string, string[]>>((acc, item) => {
  if (item.listItems) {
    // For children, the parent chain starts with the top-level label.
    Object.assign(acc, buildPathParentMapping(item.listItems, [item.label]));
  } else if (item.path) {
    // If a top-level item happens to have a path.
    acc[item.path] = [];
  }
  return acc;
}, {});
